export {
auth
} from "./auth"
export{
    addAnime
}from "./addAnime"


// WEBPACK FOOTER //
// ./src/store/action/index.js